<!--
  2021-06-18 CHP Add Gift logic here
  2021-07-17 CHP 增加GiftPop\BonusPop相关逻辑
  2021-07-26 CHP 增加UpdateVersionPop相关逻辑
  2021-08-03 CHP 增加Promotion弹框
  2021-11-29 CHP 梳理IsAppCid控制GiftPop相关逻辑
  2021-12-09 WXJ 恢复GiftPop弹出
2022-09-17 Matt 强弹图调整 Trello#113
-->
<template>
  <div class="main-content" v-show="$route.name.toLowerCase()!=='cashwheel'"
       :style="$route.name.toLocaleLowerCase() === 'home'&&($store.state.isAndroidBrowser||$store.state.showGuideBar)?'height:96px;':'height:56px'">
    <div v-show="$route.name.toLocaleLowerCase() === 'home'&&$store.state.isAndroidBrowser"
         class="downloadAndroidBar"
         :style="{backgroundImage:'url(../static/images/android_pge.webp)'}"
    >
      <span class="downLoadText"
            :style="$store.state.locale==='IN'?'font-size:3.6vw':''">{{ $t('lang.home.downLoadText')[0] }}</span>
      <!--      <span class="downLoadAmount">{{ '₹' + $store.state.hostGet }}</span>
            <span class="downLoadText">{{ $t('lang.home.downLoadText')[1] }}</span>-->
      <img class="download" :src="downloadImg" @click="downloadApp" alt="download"/>
      <img class="closeDownload" :src="closeDownload" @click="closeDownloadApp" alt="closeDownload"/>
    </div>
    <div v-show="$route.name.toLocaleLowerCase() === 'home'&&$store.state.showGuideBar" class="downloadAndroidBar"
         :style="{backgroundImage:'url(../static/images/android_guide.webp)'}"
    >
      <span class="downLoadText">{{ $t('lang.home.saveText')[0] }}</span>
      <img class="download" :src="goImg" @click="gotoGuide" alt="download"/>
      <img class="closeDownload" :src="closeDownload" @click="closeGuide()" alt="closeDownload"/>
    </div>
    <div class="topBar">
      <div class="insetLight"
           v-if="$route.name.toLocaleLowerCase() === 'home' && ($store.state.isAndroidBrowser||$store.state.showGuideBar)">
        <div class="shadow"/>
      </div>
      <div class="part left" style="z-index: 7">
        <div class="menuImg" @click="onShowLeftMenu"><img :src="menuImg" alt=""></div>
        <div class="HomeLogo" @click="goto('Home')"><img :src="homeLogo" alt=""/></div>
      </div>
      <div class="part right" style="z-index: 7">
        <div class="login" v-if="!isLogin" @click="HomeToLogin()">
          {{ $t('lang.account.login') }} \ {{ $t('lang.account.register') }}
          <div v-if="getBonusBoxShow" class="getBonusBox" :style="{backgroundImage:'url('+require('../../assets/images/TopBar/getBonusBoxBg.png')+')'}">
            <img src="../../assets/images/TopBar/currency2.png" style="height: 5vw;width: 5vw" alt="" class="coin"/>
            <div  v-html="$t('lang.account.registerGet')"></div>
            <img @click.stop="getBonusBoxShow = false" src="../../assets/images/TopBar/close.png" alt="" class="closeBtn">
          </div>
        </div>
        <div class="cash" v-else>
          <!--<img :src="showCash?moneyAct:money" alt="" @click="showCash=!showCash">-->
          <div class="gold">
            <div class="item">
              <span class="currency"  @click="goto('Account')">{{ $t('lang.account.currencyType') }}</span>
              <span  @click="goto('Account')">{{ separateThousand(balance) }}</span>
              <div class="refresh" v-cool:1900="refreshBalance"><img :src="refreshImg" alt=""/></div>
            </div>
          </div>
          <div class="vip">
            <img class="crown" :src="vipLevel" @click="goto('Vip')" alt="">
            <div class="red-circle" v-show="$store.state.vipHint"/>
          </div>
          <div class="message" @click="goto('Message')">
            <div class="haveNew" v-if="$store.state.hasCashBonus"><span>{{ $store.state.msgCount }}</span></div>
            <img :src="mail" alt="">
          </div>
        </div>
      </div>
    </div>
    <Menu
      :isLogin="isLogin"
      :userInfo="userInfo"
      v-show="$store.state.showLeftMenu"
    />
<!--    <MaintenancePop
      v-show="maintenancePopShowing&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      :closePopFunc="closePopFunc"
    />-->
    <VersionUpdatePop
      v-show="$store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop"
      promptType="1"
      :handleClose="closeVersionUpdate"
    />
    <Days7GiftPop
      @openDonwloadBonusPop="openDonwloadBonusPop()"
      v-show="verifyIfPopup7DayGift&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      :handleClose="closeGiftPop"
      :verifyIfPopup7DayGift="verifyIfPopup7DayGift"
      :closeRegularlyActivityPop="closeRegularlyActivityPop"
    />
    <NewcomerSignInPop
      :VersionCData="VersionCData"
      v-if="NewcomerSignInPop"
      @handleClose="closeNewcomerSignInPop"/>
    <NewInviteHomePop
      @handleClose="closNewInviteHomePop"
      v-if="NewInviteHomePop || NewInviteHomePopShow"
    />
    <DepositCallbackBonus
      v-if="userInfo&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      v-show="showDepositCallBackPop"
    />
<!--    <RegularlyActivityPop
      v-if="userInfo"
      v-show="showRegularlyActivityPop&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      :handleClose="closeRegularlyActivityPop"
    />-->
    <shareFiestaPop
      v-if="userInfo&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)&&showJiliActivityPop"
      :handleClose="closeJiliActivityPop"
    />
    <JiliActivity2Pop
      v-if="userInfo&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      v-show="showJiliActivity2Pop"
      :handleClose="closeJiliActivity2Pop"
    />
    <CashWheelPop
      v-if="userInfo"
      v-show="showCashWheelPop"
    />
    <VipPop
      v-if="userInfo&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      v-show="showVipPop"
      :handleClose="closeVipPop"
    />
    <InnerMsgPop
      v-if="userInfo&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      v-show="showInnerMsgPop"
      :handleClose="closeInnerMsgPop"
    />
    <ComeOnAgent
      v-if="userInfo"
      v-show="showAgentPop&&!($store.state.hasNewApkVersion &&
       !$store.state.hideVersionUpdatePop)"
      :handleClose="closeAgentPop"
    />
      <SystemAnnouncement :announcementData="announcement" @handleClose="closeSystemAnnouncementPop"  v-show="announcementShow" />
    <keep-alive>
      <GameIframe :gameInfo="gameInfo" :play="true" v-show="showGame&&isHomePage"/>
    </keep-alive>
    <HiddenIframe :url="hiddenUrl" v-if="hiddenUrl"></HiddenIframe>
  </div>
</template>

<script>
import homeLogo from '@/assets/images/TopBar/homeLogo.png'
import v0 from '@/assets/images/TopBar/home_v0.svg'
import v1 from '@/assets/images/TopBar/home_v1.svg'
import v2 from '@/assets/images/TopBar/home_v2.svg'
import v3 from '@/assets/images/TopBar/home_v3.svg'
import v4 from '@/assets/images/TopBar/home_v4.svg'
import v5 from '@/assets/images/TopBar/home_v5.svg'
import v6 from '@/assets/images/TopBar/home_v6.svg'
import v7 from '@/assets/images/TopBar/home_v7.svg'
import v8 from '@/assets/images/TopBar/home_v8.svg'
import v9 from '@/assets/images/TopBar/home_v9.svg'
import v10 from '@/assets/images/TopBar/home_v10.svg'
import v11 from '@/assets/images/TopBar/home_v11.svg'
import GameIframe from '@/components/GameIframe/index'
import menuImg from '@/assets/images/TopBar/Menu.svg'
import refreshImg from '@/assets/images/TopBar/refresh.png'
import downloadImg from '@/assets/images/common/android_download.png'
import goImg from '@/assets/images/common/topGo.webp'
import closeDownload from '@/assets/images/common/android_close.png'
import bonus from '@/assets/images/TopBar/bonus.svg'
import bonusAct from '@/assets/images/TopBar/bonusAct.svg'
import money from '@/assets/images/TopBar/money.svg'
import moneyAct from '@/assets/images/TopBar/moneyAct.svg'
import mail from '@/assets/images/TopBar/mail.svg'
import mailNew from '@/assets/images/TopBar/mailNew.svg'
import message from '@/assets/images/TopBar/messageAct.svg'
import Menu from '../Menu/index'
import {clickEvent, closePop, fetchBalance, isIOS, LogUtils, separateThousand, setCurrentModal} from '@/utils'
import request from '@/service'
import request2 from '@/service2'
import {fetchCurrency} from '@/constant'
import {mapMutations} from 'vuex'
import Days7GiftPop from '@/components/DailyFreeCash/index'
// import MaintenancePop from '@/components/MaintenancePop/index'
import VersionUpdatePop from '@/components/VersionUpdatePop/index'
import triangle from '@/assets/images/common/triangle.svg'
import DepositCallbackBonus from '@/components/DepositCallback/bonus'
import loginBtnEN from '@/assets/images/login/login-EN.webp'
import RegularlyActivityPop from '@/components/RegularlyActivityPop'
import JiliActivity2Pop from '@/components/JiliActivity2Pop'
import shareFiestaPop from '@/components/JiliActivityPop'
import InnerMsgPop from '@/components/InnerMsgPop/index.vue'
import SlotMachine from '@/components/SlotMachine'
import ComeOnAgent from '@/components/ComeOnAgent'
import loginBtnIN from '@/assets/images/login/login-IN.webp'
import VipPop from '@/components/VipPop/index.vue'
import store from '@/store/store'
import config from '../../../static/config/config'
import SystemAnnouncement from '@/components/SystemAnnouncement'
import CashWheelPop from '@/components/CashWheelPop'
// import CashWheelPop from '@/components/PredictPop'
import NewcomerSignInPop from '@/components/NewcomerSignInPop'
import NewInviteHomePop from '@/components/NewInviteHomePop'
import HiddenIframe from '@/components/HiddenIframe/index'

export default {
  name: 'TopBar',
  data () {
    return {
      hiddenUrl: null,
      getBonusBoxShow: false,
      NewcomerSignInPopShow: false,
      NewInviteHomePopShow: false,
      checkOK: false,
      showGame: false,
      isHomePage: false,
      gameInfo: {},
      depositRoutes: ['Deposit', 'Account', 'Withdraw'],
      includesRoutes: ['PromotionGame', 'Vip', 'CashBack', 'Home', 'SportsBetting'],
      NotIncludesRoutes: ['PromotionGame', 'Vip', 'CashBack', 'Home', 'Deposit'],
      showSlotsPop: true,
      menuImg,
      homeLogo,
      refreshImg,
      bonus,
      goImg,
      downloadImg,
      closeDownload,
      bonusAct,
      money,
      moneyAct,
      mail,
      mailNew,
      message,
      separateThousand,
      fetchBalance,
      fetchCurrency,
      isLogin: !!localStorage.getItem('userInfo'),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showCash: true,
      newMail: false,
      showMenu: false,
      showGiftAd: true,
      isProduction: true,
      countryList: [],
      triangle,
      showCountryDDL: true,
      loginBtn: loginBtnEN,
      maintenancePopShowing: false,
      vipLevel: v0,
      lang: localStorage.getItem('locale'),
      isOpenAnnouncement: false,
      VersionCData: {}, // 新手签到数据
      announcement: {
        title: '',
        content: '',
        picture: '',
        url: '',
        router: ''
      },
      balance: 0
    }
  },
  components: {
    VipPop,
    Menu,
    GameIframe,
    HiddenIframe,
    Days7GiftPop,
    VersionUpdatePop,
    // MaintenancePop,
    DepositCallbackBonus,
    RegularlyActivityPop,
    JiliActivity2Pop,
    shareFiestaPop,
    SlotMachine,
    InnerMsgPop,
    ComeOnAgent,
    SystemAnnouncement,
    CashWheelPop,
    NewcomerSignInPop,
    NewInviteHomePop
  },
  computed: {
    verifyIfPopup7DayGift: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 0) {
          return modals[0].showing
        } else {
          return false
        }
      }
    },
    showDepositCallBackPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 2) {
          return modals[2].showing
        } else {
          return false
        }
      }
    },
    showRegularlyActivityPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 3) {
          return modals[3].showing
        } else {
          return false
        }
      }
    },
    showJiliActivityPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 5) {
          return modals[5].showing
        } else {
          return false
        }
      }
    },
    showCashWheelPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 15) {
          return modals[15].showing
        } else {
          return false
        }
      }
    },
    NewcomerSignInPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 16) {
          return modals[16].showing
        } else {
          return false
        }
      }
    },
    NewInviteHomePop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 18) {
          return modals[18].showing
        } else {
          return false
        }
      }
    },
    showJiliActivity2Pop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 9) {
          return modals[9].showing
        } else {
          return false
        }
      }
    },
    showVipPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 10) {
          return modals[10].showing
        } else {
          return false
        }
      }
    },
    showInnerMsgPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 11) {
          return modals[11].showing
        } else {
          return false
        }
      }
    },
    showAgentPop: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 13) {
          return modals[13].showing
        } else {
          return false
        }
      }
    },
    announcementShow: {
      cache: false,
      get () {
        const currentModalIndex = store.state.currentModalIndex
        const modals = store.state.modals
        if (currentModalIndex === 14) {
          return modals[14].showing
        } else {
          return false
        }
      }
    }
  },
  mounted () {
    try {
      this.initDepositAndWin()
    } catch (e) {
    }
    this.unclaimedCashBonus()
    this.getHiddenUrl()
    let _this = this
    let previousWidth = window.innerWidth
    // 防止用户访问窗口宽度变化导致失真
    window.addEventListener('resize', function () {
      const currentWidth = window.innerWidth
      if (currentWidth !== previousWidth) {
        if (_this.$route && (_this.$route.name === 'Home' || _this.$route.name.toLowerCase() === 'vip' || _this.$route.name === 'Promotion')) {
          setTimeout(() => {
            window.location.reload()
          }, 50)
        }
      }
    })
    if (!this.isSameDay(new Date().getTime(), this.$store.state.modals[11].updateDateSpan)) {
      localStorage.removeItem('pop11ban')
    }
    this.isHomePage = this.includesRoutes.includes(this.$route.name)
    this.fetchVipLevel()
    this.isProduction = process.env.NODE_ENV !== 'development'
    // 获取小红点
    LogUtils.getRedDot(this.userInfo)
    // 2022-06-21 YTW 检查更新
    LogUtils.checkUpdate(config.version)
    // 2022-06-21 CHP 召回检查
    // 2022-11-30 HHY 重新加载检查用户是否为回归用户
    LogUtils.checkCallback()
    const sendLocaleTime = localStorage.getItem('sendLocaleTime')
    const now = Date.now()
    if (!sendLocaleTime) {
      localStorage.setItem('sendLocaleTime', Date.now() + '')
    } else if (!this.isSameDay(now, sendLocaleTime * 1)) {
      localStorage.setItem('sendLocaleTime', Date.now() + '')
    }
    this.$store.commit('setIsAndroidBrowser', this.jurgeAndroidBrowser())
    if (localStorage.getItem('userInfo')) {
      this.fetchBalance()
      this.getUserGiftCollectInfo()
      setInterval(() => {
        if (!store.state.userOnGame) {
          this.fetchBalance()
        }
      }, 60000) // 更新余额
    } else {
      const url = '/innovation/sevendaygift/get-gift-amount'
      let data = {}
      if (localStorage.getItem('cid')) {
        data.campaignId = localStorage.getItem('cid')
      } else {
        data.campaignId = 'app'
      }
      request('post', url, data, true).then(res => {
        if (res && (res.SevenDayGiftTask || res.SevenDayGiftModel)) {
          store.commit('setGiftCollectInfo', {
            mayCollectDeposit: false,
            mayCollectFree: false,
            numberOfDay: 0,
            hasGiftLeft: true,
            showGiftIcon: true
          })
        } else {
          store.commit('setGiftCollectInfo', {
            mayCollectDeposit: false,
            mayCollectFree: false,
            numberOfDay: 0,
            hasGiftLeft: true,
            showGiftIcon: false
          })
        }
        // 没有登入信息 弹出七日签到弹窗
        if (store.state.showGiftIcon && this.$route.name.toLocaleLowerCase() === 'home') {
          store.commit('setCurrentModalIndex', 0)
          setCurrentModal(0)
        }
        this.$store.state.lazyEnd = true
      }).catch(err => {
        console.log(err)
      })
    }
    setTimeout(
      () => {
        if (this.$route.name.toLocaleLowerCase() === 'home') { // 在主页的前提下弹出,防止再次回到主页时弹窗冲突
          let giftCollectInfo = store.state.giftCollectInfo
          if (localStorage.getItem('userInfo')) {
            this.$store.state.lazyEnd = true
            if (this.isOpenAnnouncement) {
              store.commit('setCurrentModalIndex', 14)
              setCurrentModal(14)
            } else if (this.NewcomerSignInPopShow) { // 新人签到
              store.commit('setCurrentModalIndex', 16)
              setCurrentModal(16)
            } else if (store.state.modals[18].popupTimes < store.state.modals[18].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 18)
              setCurrentModal(18)
            } else if (store.state.showGiftIcon && giftCollectInfo && giftCollectInfo.hasGiftLeft && !this.NewcomerSignInPopShow && (giftCollectInfo.mayCollectDeposit || giftCollectInfo.mayCollectFree)) { // 可签到礼包
              store.commit('setCurrentModalIndex', 16)// 允许弹出七日礼包
              setCurrentModal(16)
            } else if (store.state.userFirstDeposit === true) { // 七日礼包今日没有弹出次数
              store.commit('setCurrentModalIndex', 1) // 允许弹出首充礼包
              setCurrentModal(1)
            } else if (store.state.callbackTimeSpan > (new Date()).getTime()) {
              store.commit('setCurrentModalIndex', 2) // 允许弹出回归礼包
              setCurrentModal(2)
            } else if (store.state.modals[15].popupTimes < store.state.modals[15].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 15) // 允许弹出回归礼包
              setCurrentModal(15)
            } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes && store.state.show5thIcon) {
              store.commit('setCurrentModalIndex', 3) // 允许弹出常态化流水活动
              setCurrentModal(3)
            } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
              store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
              setCurrentModal(5)
            } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
              store.commit('setCurrentModalIndex', 11) // 站内信
              setCurrentModal(11)
            } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 13)
              setCurrentModal(13)
            }
          } else {
            store.commit('setCurrentModalIndex', 16)// 允许弹出七日礼包
            setCurrentModal(16)
          }
        }
      },
      2000
    )
    this.getUncollectReward()
  },
  watch: {
    '$route': function (to) {
      this.isHomePage = this.includesRoutes.includes(to.name)
      this.unclaimedCashBonus()
      if (!this.NotIncludesRoutes.includes(to.name) && this.showGame) {
        this.$store.commit('setGameInfo', {})
        this.$store.commit('setShowGame', false)
      }
      if (this.userInfo && this.depositRoutes.includes(to.name)) {
        this.fetchBalance()
      }
      if (this.isHomePage) {
        try {
          this.initDepositAndWin()
        } catch (e) {
        }
      }
    },
    '$store.state.msgCountFresh': function () {
      this.unclaimedCashBonus()
    },
    '$store.state.balance.Total': function () {
      this.balance = this.$store.state.balance.Total
    },
    '$store.state.hasNewApkVersion': function (n, o) {
      if (!this.$store.state.hideVersionUpdatePop && n) {
        closePop(0)
        closePop(1)
        closePop(2)
        closePop(3)
        closePop(4)
        closePop(5)
        closePop(6)
        closePop(7)
        closePop(8)
        closePop(9)
      }
    },
    '$store.state.locale': function (n) {
      this.lang = n
      switch (this.$store.state.locale) {
        case 'IN':
          this.loginBtn = loginBtnIN
          break
        default:
          this.loginBtn = loginBtnEN
      }
    },
    '$store.state.showGame': function (n) {
      this.$store.commit('setUserOnGame', n)
      if (n) {
        this.showGame = true
        this.gameInfo = this.$store.state.gameInfo
      } else {
        this.showGame = false
        this.gameInfo = {}
      }
    },
    '$store.state.userVipInfo': function (n) {
      this.fetchVipLevel()
    }
  },
  created () {
    this.$store.state.lazyEnd = false
    switch (this.$store.state.locale) {
      case 'IN':
        this.loginBtn = loginBtnIN
        break
      default:
        this.loginBtn = loginBtnEN
    }
  },
  updated () {
  },
  activated () {
  },
  beforeDestroy () {
    closePop(0)
    closePop(5)
    closePop(9)
  },
  methods: {
    ...mapMutations({
      setNewMail: 'setNewMail',
      setInternation: 'setInternation',
      setInternationName: 'setInternationName',
      setLocale: 'setLocale',
      setCurrentRoute: 'setCurrentRoute'
    }),
    refreshBalance () {
      LogUtils.logout9w()
      this.fetchBalance()
      this.balance = 0
      this.doFresh()
    },
    logout9w () {
      let user = localStorage.getItem('userInfo')
      if (user !== null) {
        const url = '/innovation/w9/withdrawal'
        const data = {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId
        }
        request('post', url, data, false).then(res => {
          console.log(res)
        })
      }
    },
    doFresh () {
      if (this.balance < this.$store.state.balance.Total) {
        this.balance += parseFloat((this.$store.state.balance.Total / 10).toFixed(2))
        setTimeout(() => {
          this.doFresh()
        }, 70)
      } else {
        this.balance = this.$store.state.balance.Total
      }
    },
    // 查询用户待领取邀请奖励
    getUncollectReward () {
      if (!this.userInfo) {
        return
      }
      const url = '/innovation/invite_relation/get/uncollect/reward'
      const data = {
        UserId: this.userInfo ? this.userInfo.UserId : ''
      }
      request('post', url, data).then(res => {
        if (res) {
          this.$store.state.footerEarn = res.Total
        }
      })
    },
    HomeToLogin () {
      this.sendHomeToEvent()
      this.$router.push('/Login')
    },
    sendHomeToEvent () {
      const url = '/innovation/account/save/user/event'
      const data = {
        EventNameEN: 'HomeToLogin',
        UserUniqueId: this.userInfo === null ? null : this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    claimGuideBonus () {
      request('post', 'innovation/home/get/guideBonus', {UserId: this.userInfo.UserId}, true).then(res => {
        if (res !== -1) {
          store.commit('setShowGuideBar', false)
          localStorage.setItem('guideTime-' + this.userInfo.UserId, Date.now())
        }
      }).catch(err => {
        console.log(err)
      })
    },
    downloadApp () {
      LogUtils.downloadApp('ClickTopDown')
    },
    gotoGuide () {
      if (!this.userInfo) {
        this.$router.push('/Login')
        return
      }
      this.claimGuideBonus()
      let end = ''
      if (localStorage.getItem('apkV') && localStorage.getItem('cid')) {
        end = '?cid=' + localStorage.getItem('cid') + '&v=' + localStorage.getItem('apkV')
      } else if (localStorage.getItem('apkV') && !localStorage.getItem('cid')) {
        end = '?v=' + localStorage.getItem('apkV')
      } else if (!localStorage.getItem('apkV') && localStorage.getItem('cid')) {
        end = '?cid=' + localStorage.getItem('cid')
      }
      if (window.Android) {
        end = end + '&a=true&w=whatsapp'
        window.location.href = 'https://playgoeasy.com' + end
      } else {
        end = end + '&a=false'
        window.open('https://playgoeasy.com' + end)
      }
    },
    closeGuide () {
      let key = ''
      if (this.userInfo) {
        key = 'guideTime-' + this.userInfo.UserId
      } else {
        key = 'guideTime'
      }
      store.commit('setShowGuideBar', false)
      localStorage.setItem(key, Date.now())
    },
    closeDownloadApp () {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const now = Date.now()
      if (!userInfo) {
        localStorage.setItem('closeStreamerSpan-Logout', now)
      } else {
        localStorage.setItem('closeStreamerSpan-' + userInfo.UserId, now)
      }
      this.$store.commit('setIsAndroidBrowser', this.jurgeAndroidBrowser())
    },
    jurgeAndroidBrowser () {
      const sysJudge = typeof window.Android === 'undefined' && !isIOS()
      if (sysJudge) {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        const now = Date.now()
        let recordTime = null
        if (!userInfo) {
          recordTime = localStorage.getItem('closeStreamerSpan-Logout')
        } else {
          recordTime = localStorage.getItem('closeStreamerSpan-' + userInfo.UserId)
        }
        if (!recordTime) {
          return true
        } else {
          return !this.isSameDay(now * 1, recordTime * 1)
        }
      } else {
        return false
      }
    },
    isSameDay (timestamp1, timestamp2) {
      const date1 = new Date(timestamp1)
      const date2 = new Date(timestamp2)

      // 获取日期部分，忽略时间部分
      const day1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate())
      const day2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate())

      // 比较两个日期部分是否相等
      return day1.getTime() === day2.getTime()
    },
    getAnnouncement () {
      if (this.userInfo) {
        request('post', 'innovation/home/get/announcement', {CampaignId: this.userInfo.CampaignId}, true).then(res => {
          if (res) {
            if (this.lang === 'EN') {
              this.announcement.title = res.TitleEN
              if (res.ContentEN) {
                this.announcement.content = res.ContentEN.replace(/\n/g, '<br>')
              }
              this.announcement.picture = res.PictureEN
              this.announcement.url = res.Url
              this.announcement.router = res.Router
            } else {
              this.announcement.title = res.TitleIN
              if (res.ContentIN) {
                this.announcement.content = res.ContentIN.replace(/\n/g, '<br>')
              }
              this.announcement.picture = res.PictureIN
              this.announcement.url = res.Url
              this.announcement.router = res.Router
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    async initDepositAndWin () {
      if (this.userInfo) {
        const cid = localStorage.getItem('cid') || 'app'
        const local = this.$store.state.locale
        const visitorCode = await LogUtils.getVisitorCode()
        const data = {
          userId: this.userInfo ? this.userInfo.UserId : null,
          campaignId: cid,
          localVersion: local,
          visitorCode: visitorCode
        }
        request('post', 'innovation/home/get-user-settings', data, true).then(res => {
          if (res) {
            store.commit('setDepositActivityIcon', res.DepositTaskSwitch)
            store.commit('setBetRewardHot', res.BetRewardHot)
            store.commit('setCashBackHot', res.CashBackHot)
            store.commit('setShowInviteRedDot', res.ShowInviteRedDot)
            if (!res.NavigationTaskCompleted || res.NavigationTaskCompleted !== 1) {
              const guideTime = localStorage.getItem('guideTime-' + this.userInfo.UserId)
              store.commit('setShowGuideBar', !(guideTime && LogUtils.isSameDay(Date.now() * 1, guideTime * 1)))
            } else {
              store.commit('setShowGuideBar', false)
            }
            // ShowPromotionRedDot promotion是否有可领（除c版签到，c版签到是否有可领前端处理）
            store.commit('setShowPromotionRedDot', res.ShowPromotionRedDot)
            // HasSignRoute 是否配置有c版签到的promotion
            store.commit('setIsHavePromotionVersionC', res.HasSignRoute)
            if (res.AnnouncementCode) {
              if (res.AnnouncementCode === localStorage.getItem('AnnouncementCode') && localStorage.getItem('AnnouncementCode')) {
                this.isOpenAnnouncement = false
              } else {
                this.isOpenAnnouncement = true
              }
              localStorage.setItem('AnnouncementCode', res.AnnouncementCode)
              this.getAnnouncement()
            }
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        const guideTime = localStorage.getItem('guideTime')
        store.commit('setShowGuideBar', !(guideTime && LogUtils.isSameDay(Date.now() * 1, guideTime * 1)))
      }
    },
    getUserGiftCollectInfo () {
      store.commit('setGiftLoadingInfoStatus', true)
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo) {
        const url = '/innovation/sevendaygift/get-user-info'
        const data = {
          userId: userInfo.UserId
        }
        store.commit('setGiftLoadingInfoStatus', true)
        request('post', url, data, true).then(res => {
          if (res && res.SevenDayGiftModel === 'free_deposit') {
            localStorage.setItem('SevenDayGiftModel', res.SevenDayGiftModel)
            store.commit('setGiftCollectInfo', {
              mayCollectDeposit: res.MayCollectDeposit,
              mayCollectFree: res.MayCollectFree,
              numberOfDay: res.NumberOfDay,
              hasGiftLeft: res.NumberOfDay < 7 || res.MayCollectDeposit || res.MayCollectFree,
              isDeposited: res.IsDeposited
            })
            store.commit('setGiftLoadingInfoStatus', false)
          } else if (res && res.SevenDayGiftModel && res.SevenDayGiftModel === 'version_task' && res.SevenDayGiftTask && res.SevenDayGiftTask.length > 0) {
            localStorage.setItem('SevenDayGiftModel', res.SevenDayGiftModel)
            store.commit('setGiftCollectInfo', {
              mayCollectDeposit: true,
              mayCollectFree: true,
              numberOfDay: 0,
              hasGiftLeft: true,
              isDeposited: res.IsDeposited
            })
            store.commit('setGiftLoadingInfoStatus', false)
          } else if (res && res.SevenDayGiftModel && res.SevenDayGiftModel === 'version_task' && (!res.SevenDayGiftTask || res.SevenDayGiftTask.length <= 0)) {
            localStorage.setItem('SevenDayGiftModel', res.SevenDayGiftModel)
            store.commit('setGiftCollectInfo', {
              mayCollectDeposit: false,
              mayCollectFree: false,
              numberOfDay: res.NumberOfDay,
              hasGiftLeft: true,
              isDeposited: res.IsDeposited
            })
            store.commit('setGiftLoadingInfoStatus', false)
          } else if (res && res.SevenDayGiftModel && res.SevenDayGiftModel === 'versionC' && res.VersionCRewardList) {
            localStorage.setItem('SevenDayGiftModel', res.SevenDayGiftModel)
            this.NewcomerSignInPopShow = true
            this.VersionCData = {
              VersionCRewardList: res.VersionCRewardList, // 签到数据
              VersionCWaitClaimTasks: res.VersionCWaitClaimTasks, // 待领取和进行中的任务列表(已排序)
              VersionCDoneTasks: res.VersionCDoneTasks, // 完成的任务列表
              EndTime: res.EndTime
            }
          }
          let IsShowIcon = false
          if (res.IsShowIcon) {
            IsShowIcon = true
          }
          store.commit('setShowGiftIcon', IsShowIcon)
        }).catch(err => {
          console.log(err)
          store.commit('setGiftLoadingInfoStatus', false)
        })
      } else {
        store.commit('setHideGiftPop', true)
        store.commit('setGiftLoadingInfoStatus', false)
      }
    },
    closePopFunc () {
      this.maintenancePopShowing = false
    },
    fetchUnreadCount () {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo) {
        const url = '/innovation/message/getnotreadmessagescount'
        const data = {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId
        }
        request2('post', url, data, true).then(res => {
          res.NotReadMessagesCount.forEach(item => {
            if (item.Count > 0) this.newMail = true
          })
          this.setNewMail(this.newMail)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    getInternationCountryList () {
      const url = '/innovation/internal/getinternationcountrylist'
      const data = {}
      request('post', url, data, false)
        .then(res => {
          console.log('---- getInternationCountryList', res)
          this.countryList = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    onShowCountryDDL () {
      this.showCountryDDL = !this.showCountryDDL
    },
    getHiddenUrl () {
      if (localStorage.getItem('fromRegister') && localStorage.getItem('userInfo')) {
        const data = {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId
        }
        request('post', '/innovation/omg/get/gameurl', data, true)
          .then(res => {
            if (res && res.code === 1) {
              localStorage.removeItem('fromRegister')
              if (res.url) {
                this.hiddenUrl = res.url
                setTimeout(() => {
                  this.hiddenUrl = null
                }, 10000)
              }
            }
          })
      }
    },
    // 获取国家版本
    fetchVipLevel () {
      if (!this.userInfo || !this.userInfo.UserId || !this.$store.state.userVipInfo) {
        return
      }
      switch (this.$store.state.userVipInfo.VipLevel) {
        default:
          this.vipLevel = v0
          break
        case 1:
          this.vipLevel = v1
          break
        case 2:
          this.vipLevel = v2
          break
        case 3:
          this.vipLevel = v3
          break
        case 4:
          this.vipLevel = v4
          break
        case 5:
          this.vipLevel = v5
          break
        case 6:
          this.vipLevel = v6
          break
        case 7:
          this.vipLevel = v7
          break
        case 8:
          this.vipLevel = v8
          break
        case 9:
          this.vipLevel = v9
          break
        case 10:
          this.vipLevel = v10
          break
        case 11:
          this.vipLevel = v11
          break
      }
      if (this.$store.state.userVipInfo.Birthday) {
        sessionStorage.Birthday = this.$store.state.userVipInfo.Birthday
      } else {
        sessionStorage.removeItem('Birthday')
      }
      this.$store.commit('setVipHint', this.$store.state.userVipInfo.VipLevelReward > 0 || this.$store.state.userVipInfo.VipWeekReward > 0)
    },
    /***
     * 选择国家版本
     * @param internation
     * 2021-10-31 CHP 增加设置国家版本名字、语言
     */
    selectCountry (internation) {
      this.showCountryDDL = !this.showCountryDDL
      this.setInternation(internation.CountryCode)
      // 2021-10-31 CHP 增加设置国家版本名字、语言
      this.setInternationName(internation.CountryNameLocal)
      localStorage.setItem('locale', internation.Language)
      this.$i18n.locale = internation.Language // localStorage.getItem('locale') // todo 切换版本
    },
    close () {
      store.commit('setShowLeftMenu', false)
    },
    goto (path) {
      if (this.$route.name === path) return
      if (path === 'Bonus') this.$store.state.showBonusHint = false // 关闭提示bonus的气泡框 by HHY 20220607
      if (path === 'Account' || path === 'Earn') {
        this.setCurrentRoute(path)
      }
      if (path === 'Vip' || path === 'Message') {
        clickEvent({EventNameEN: 'topBarClick' + path})
      }
      this.close()
      this.$router.push('/' + path)
    },
    closeGiftPop () {
      if (store.state.giftIconClicked) {
        store.commit('setGiftIconClicked', false)
        closePop(0)
        return
      } else {
        closePop(0)
      }
      setTimeout(
        () => {
          if (this.userInfo && this.$route.name.toLocaleLowerCase() === 'home') {
            this.NewInviteHomePopShow = false
            if (store.state.modals[18].popupTimes < store.state.modals[18].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 18)
              setCurrentModal(18)
            } else if (store.state.userFirstDeposit === true) { // 首充用户
              store.commit('setCurrentModalIndex', 1)
              setCurrentModal(1)
            } else if (store.state.callbackTimeSpan > (new Date()).getTime()) { // 回归用户
              store.commit('setCurrentModalIndex', 2)
              setCurrentModal(2)
            } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes && store.state.show5thIcon) {
              store.commit('setCurrentModalIndex', 3)
              setCurrentModal(3)
            } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
              store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
              setCurrentModal(5)
            } else if (store.state.modals[10].popupTimes < store.state.modals[10].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 10)
              setCurrentModal(10)
            } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
              store.commit('setCurrentModalIndex', 11) // 站内信
              setCurrentModal(11)
            } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
              store.commit('setCurrentModalIndex', 13)
              setCurrentModal(13)
            }
          } else if (!this.userInfo) {
            // this.NewInviteHomePopShow = true
          } else if (!this.userInfo && this.$route.name.toLocaleLowerCase() === 'home') {
            store.commit('setCurrentModalIndex', 13) // 代理招募
            setCurrentModal(13)
          }
        }, 500)
    },
    closeRegularlyActivityPop () {
      closePop(3)
      if (store.state.modals[10].popupTimes < store.state.modals[10].maxPopupTimes && this.$route.name.toLocaleLowerCase() === 'home') {
        store.commit('setCurrentModalIndex', 10) // vip弹窗
        setCurrentModal(10)
      } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
        store.commit('setCurrentModalIndex', 11) // 站内信
        setCurrentModal(11)
      } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 13)
        setCurrentModal(13)
      }
    },
    closeJiliActivityPop () {
      closePop(5)
      if (store.state.modals[9].popupTimes < store.state.modals[9].maxPopupTimes && this.$route.name.toLocaleLowerCase() === 'home') {
        let currentDate = new Date().getTime()
        let date = new Date('2023-09-06T00:00:00Z')
        let timestamp = date.getTime()
        if (timestamp > currentDate) {
          store.commit('setCurrentModalIndex', 9)
          setCurrentModal(9)
        }
      } else if (store.state.modals[10].popupTimes < store.state.modals[10].maxPopupTimes && this.$route.name.toLocaleLowerCase() === 'home') {
        store.commit('setCurrentModalIndex', 10) // vip弹窗
        setCurrentModal(10)
      } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
        store.commit('setCurrentModalIndex', 11) // 站内信
        setCurrentModal(11)
      } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 13)
        setCurrentModal(13)
      }
    },
    closeJiliActivity2Pop () {
      closePop(9)
      if (store.state.modals[10].popupTimes < store.state.modals[10].maxPopupTimes && this.$route.name.toLocaleLowerCase() === 'home') {
        store.commit('setCurrentModalIndex', 10) // vip弹窗
        setCurrentModal(10)
      } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
        store.commit('setCurrentModalIndex', 11) // 站内信
        setCurrentModal(11)
      } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 13)
        setCurrentModal(13)
      }
    },
    closeVipPop () {
      closePop(10)
    },
    closeInnerMsgPop () {
      closePop(11)
    },
    closeAgentPop () {
      closePop(13)
    },
    closNewInviteHomePop () {
      closePop(18)
      this.NewInviteHomePopShow = false
      let giftCollectInfo = store.state.giftCollectInfo
      if (this.userInfo) {
        if (store.state.showGiftIcon && giftCollectInfo && giftCollectInfo.hasGiftLeft && !this.NewcomerSignInPopShow && (giftCollectInfo.mayCollectDeposit || giftCollectInfo.mayCollectFree)) { // 可签到礼包
          store.commit('setCurrentModalIndex', 0)// 允许弹出七日礼包
          setCurrentModal(0)
        } else if (store.state.userFirstDeposit === true) { // 七日礼包今日没有弹出次数
          store.commit('setCurrentModalIndex', 1) // 允许弹出首充礼包
          setCurrentModal(1)
        } else if (store.state.callbackTimeSpan > (new Date()).getTime()) {
          store.commit('setCurrentModalIndex', 2) // 允许弹出回归礼包
          setCurrentModal(2)
        } else if (store.state.modals[15].popupTimes < store.state.modals[15].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 15) // 允许弹出回归礼包
          setCurrentModal(15)
        } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes && store.state.show5thIcon) {
          store.commit('setCurrentModalIndex', 3) // 允许弹出常态化流水活动
          setCurrentModal(3)
        } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
          store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
          setCurrentModal(5)
        } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
          store.commit('setCurrentModalIndex', 11) // 站内信
          setCurrentModal(11)
        } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 13)
          setCurrentModal(13)
        }
      } else {
        if (!this.userInfo && this.$route.name.toLocaleLowerCase() === 'home') {
          store.commit('setCurrentModalIndex', 13) // 代理招募
          setCurrentModal(13)
        }
      }
    },
    closeNewcomerSignInPop () {
      closePop(16)
      let giftCollectInfo = store.state.giftCollectInfo
      if (store.state.modals[18].popupTimes < store.state.modals[18].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 18)
        setCurrentModal(18)
      } else if (store.state.showGiftIcon && giftCollectInfo && giftCollectInfo.hasGiftLeft && !this.NewcomerSignInPopShow && (giftCollectInfo.mayCollectDeposit || giftCollectInfo.mayCollectFree)) { // 可签到礼包
        store.commit('setCurrentModalIndex', 0)// 允许弹出七日礼包
        setCurrentModal(0)
      } else if (store.state.userFirstDeposit === true) { // 七日礼包今日没有弹出次数
        store.commit('setCurrentModalIndex', 1) // 允许弹出首充礼包
        setCurrentModal(1)
      } else if (store.state.callbackTimeSpan > (new Date()).getTime()) {
        store.commit('setCurrentModalIndex', 2) // 允许弹出回归礼包
        setCurrentModal(2)
      } else if (store.state.modals[15].popupTimes < store.state.modals[15].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 15) // 允许弹出回归礼包
        setCurrentModal(15)
      } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes && store.state.show5thIcon) {
        store.commit('setCurrentModalIndex', 3) // 允许弹出常态化流水活动
        setCurrentModal(3)
      } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
        store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
        setCurrentModal(5)
      } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
        store.commit('setCurrentModalIndex', 11) // 站内信
        setCurrentModal(11)
      } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 13)
        setCurrentModal(13)
      }
    },
    closeSystemAnnouncementPop (goto) {
      closePop(14)
      if (goto) {
        this.$router.beforeEach((to, from, next) => {
          next()
        })
      } else {
        let giftCollectInfo = store.state.giftCollectInfo
        if (this.NewcomerSignInPopShow) {
          store.commit('setCurrentModalIndex', 16)
          setCurrentModal(16)
        } else if (store.state.showGiftIcon && giftCollectInfo && giftCollectInfo.hasGiftLeft && !this.NewcomerSignInPopShow && (giftCollectInfo.mayCollectDeposit || giftCollectInfo.mayCollectFree)) { // 可签到礼包
          store.commit('setCurrentModalIndex', 0)// 允许弹出七日礼包
          setCurrentModal(0)
        } else if (store.state.userFirstDeposit === true) { // 七日礼包今日没有弹出次数
          store.commit('setCurrentModalIndex', 1) // 允许弹出首充礼包
          setCurrentModal(1)
        } else if (store.state.callbackTimeSpan > (new Date()).getTime()) {
          store.commit('setCurrentModalIndex', 2) // 允许弹出回归礼包
          setCurrentModal(2)
        } else if (store.state.modals[15].popupTimes < store.state.modals[15].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 15) // 允许弹出回归礼包
          setCurrentModal(15)
        } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes && store.state.show5thIcon) {
          store.commit('setCurrentModalIndex', 3) // 允许弹出常态化流水活动
          setCurrentModal(3)
        } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
          store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
          setCurrentModal(5)
        } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
          store.commit('setCurrentModalIndex', 11) // 站内信
          setCurrentModal(11)
        } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 13)
          setCurrentModal(13)
        }
      }

      // this.closeGiftPop()
    },
    onShowLeftMenu () {
      store.commit('setShowLeftMenu', true)
      clickEvent({EventNameEN: 'showMenu'})
    },
    closeVersionUpdate () {
    },
    openDonwloadBonusPop () {
      setTimeout(() => {
        this.getBonusBoxShow = true
      }, 1000)
    },
    unclaimedCashBonus () {
      const user = localStorage.getItem('userInfo')
      if (user !== null) {
        const url = '/innovation/newmessage/unclaimedcashbonus'
        const data = {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          messageType: 'system'
        }
        request2('post', url, data).then(res => {
          if (res > 0) {
            if (res === this.$store.state.msgCount) {
              return
            }
            this.$store.commit('setMsgCount', res > 99 ? 99 : res)
            this.$store.commit('setIfHaveCashOrBonus', true)
          } else {
            this.$store.commit('setMsgCount', 0)
            this.$store.commit('setIfHaveCashOrBonus', false)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  position: relative;
  //overflow: hidden;
  overflow: visible !important;
}
.downloadAndroidBar {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 56px;
  padding-left: 11vw;
  font-size: 22px;
  font-weight: 700;
  line-height: 23px;
  vertical-align: top;
  color: #000000;
  background-position: top;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 4;
  display: flex;
  padding-bottom: 4.444vw;
  align-items: center;
  .downLoadText {
    margin-top: 0.8vw;
    font-size: 3.888vw;
    font-weight: 700;
    letter-spacing: -0.05em;
    text-align: left;
  }

  .downLoadAmount {
    margin-left: 2vw;
    margin-right: 2vw;
    color: #C80303;
    font-size: 5.277vw;
    font-weight: 700;
    letter-spacing: -0.05em;
    text-align: left;
  }

  .download {
    position: absolute;
    right: 10vw;
    width: 24.166vw;
    height: 8.333vw;
    animation: zoom 250ms ease-in-out infinite alternate;
  }

  @keyframes zoom {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.15); /* 放大倍数可根据需要调整 */
    }
  }

  .closeDownload {
    position: absolute;
    right: 3.055vw;
    width: 3.333vw;
  }
}

.topBar {
  position: absolute;
  bottom: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 13.5px;
  background: #212324;
  //overflow: hidden;
  width: 100vw;
  height: 56px;

  .insetLight {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    width: calc(100vw + 20px);
    height: 56px;
    overflow: hidden;

    .shadow {
      display: none;
      width: 100%;
      height: 70px;
      box-shadow: inset 0 5px 14px 0 rgba(255, 255, 255, 0.24);
    }
  }

  .part {
    /*flex: 4;*/
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .locale {
      margin-right: 10px;
      /*width: 24px;*/
      position: relative;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      text-align: center;
      color: #F6D9AA;
      /*background-color: #fff;*/
      /*border-radius: 50%;*/

      .countryIcon {
        height: 20px;
        width: 20px;
        margin: 2px 10px 2px 0px;
        display: block;
      }

      .selectList {
        position: absolute;
        left: 0;
        top: 30px;
        padding: 15px 0;
        width: max-content;
        text-align: left;
        background: #202020;
        border: 1px solid rgba(246, 217, 170, 0.5);
        border-radius: 0 0 10px 10px;
        cursor: default;
        z-index: 5;

        .option {
          padding: 0 15px;
          line-height: 24px;
          display: flex;

          &:hover {
            background: #333;
          }

          .countryIcon {
            height: 20px;
            width: 20px;
            margin: 2px 10px 2px 0px;
            display: block;
          }
        }
      }

      .rotate {
        transform: rotateZ(90deg);
      }
    }

    .login {
      background: linear-gradient(270deg, #F9D794 0%, #E9D6B0 100%);
      border-radius: 5vw;
      font-size: 3.611vw;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      width: 36.944vw;
      height: 6.944vw;
      font-weight: 700;
      position: relative;
      border: 1px solid #fff;
      .getBonusBox{
        position: absolute;
        color: #F6D7A6;
        width: 52.763vw;
        height: auto;
        padding: 3.05vw;
        padding-top: 6vw;
        top: 8vw;
        left: -16vw;
        background-size: 100% 100%;
        overflow-wrap: normal;
        z-index: 9999;
        display: flex;
        //align-items: center;
        //flex-wrap: wrap;
        font-size: 3.333vw;
        line-height: 7vw;
        font-weight: 500;
        span{
          overflow-wrap: normal;
        }
        .closeBtn{
          position: absolute;
          height: 2.666vw;
          width: 2.666vw;
          top: 4vw;
          left: 48vw;
        }
        .coin{
          height: 5vw;
          width: 5vw;
          margin-top: 0.8vw;
          margin-right: 0.5vw;
        }
      }
      @keyframes boxEffects {
        0% {
          width: 26.944vw;
          height: 3.944vw;
          //opacity: 0.8;
          background-color: rgba(255,255,255,.8);
        }
        100% {
          width: 46.944vw;
          height: 12.944vw;
          //opacity: 0;
          background-color: rgba(255,255,255,0);
        }
      }
      &:before{
        height: 100%;
        width: 100%;
        border-radius: 50vw;
        content: '';
        //background-color: rgba(255,255,255,1);
        position: absolute;
        //bottom: 15px;
        z-index: -1;
        animation: boxEffects 1.2s ease-in infinite;
      }
    }

    .cash {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-left: 10px;
      width: calc(100vw - 100.5px);

      div {
        font-size: 12px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        padding: 0;
      }

      .gold {
        color: #F6D9AA;
        white-space: nowrap;
        width: calc(100vw - 46px - 36px);
        overflow: hidden;
        display: flex;
        justify-content: flex-end;
        padding-left: 3px;

        .item {
          min-width: 119px;
          overflow: hidden;
          background-color: #000;
          padding-left: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 5px;
          width: 129px;
          height: 23px;
          line-height: 23px;
          text-align: center;
          border-radius: 30px;
          border: 1.5px solid #F6D9AA;

          .currency {
            color: #F6D9AA;
            display: inline-block;
            width: 15px;
            height: 15px;
            line-height: 15px;
            text-align: center;
            border-radius: 50%;
          }
        }

        .refresh {
          padding: 0 5px;
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;

          img {
            height: 16px;
          }
        }
      }

      .vip {
        position: relative;
        display: flex;
        align-items: center;
        .crown {
          width: 29px;
          margin: 0 10px;
          padding-top: 2px;
        }
        .red-circle {
          position: absolute;
          top: 3px;
          right: 7px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: red;
          z-index: 3;
          overflow: visible;
          color: #686868;
          display: block;
          unicode-bidi: isolate;
        }
      }

      .message {
        position: relative;
        margin-top: 3px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 34px;
        }
        .haveNew {
          position: absolute;
          right: -5px;
          top: -3px;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          background-color: red;
          display: flex;
          justify-content: center;
          align-content: center;
          align-items: center;

          span {
            font-size: 10px;
            font-weight: 700;
            -webkit-text-stroke: 1.5px transparent;
            background: #000000 top left / 100% 100%;
            -webkit-background-clip: text;
          }
        }
      }
    }
  }

  .left {
    width: max-content;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .menuImg {
      width: 26px;
      height: 36px;
      border-radius: 1px 0px 0px 0px;
      z-index: 7;
      display: flex;
      align-items: center;
      img {
        width: 26px;
        height: 16.59px;
      }
    }
    .HomeLogo {
      margin-left: 10px;
      width: 51px;
      height: 36px;
      z-index: 7;
      display: flex;
      align-items: center;

      img {
        margin-top: 7px;
        width: 51px;
        height: 35.14px;
      }
    }
  }

  .right {
    width: calc(100vw - 114px);
  }
}

.gift-ad-pop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, .9);
  z-index: 1;
}

.gift-ad-content-wrapper {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 15px;
}

.gift-ad-content {
  margin: 20px 20px;
  line-height: 40px;
  font-size: 22px;
  color: #F6D9AA;
  text-align: justify-all;
}

.cancel-btn {
  position: absolute;
  top: 40px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar/index.vue